import React from "react";

import Table from "../../common/Table";

const PaymentsList = ({activeYear}) => {
    const paymentsColumn = [
        {path: "id", label: "شماره"},
        {path: "payment_date", label: "تاریخ"},
        {path: "paid_by_staff_name", label: "پرداخت کننده"},
        {path: "modified_by_staff_name", label: "ثبت کننده"},
        {path: "amount", label: "مبلغ"},
        { path: "bank_ref_no", label: "ریفرنس نمبر" },
        {path: "remark", label: "ملاحظه"},
    ];

    const total = activeYear?.payments?.reduce((sum, item) => sum + parseFloat(item["amount"]), 0);

    return (
        <div className="print-table-area">
            <Table
                data={activeYear?.payments}
                columns={paymentsColumn}
                total={total}
            />
        </div>
    );
};

export default PaymentsList;
